import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-produtos-arquivados',
  templateUrl: './produtos-arquivados.component.html',
  styleUrls: ['./produtos-arquivados.component.scss']
})
export class ProdutosArquivadosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/produto-components/produtos-arquivados/produtos-arquivados.component.ts